import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modalContent: {
    backgroundColor: "#1B1D28",
    borderRadius: "20px",
    width: "560px",
    maxWidth: "95vw",
    padding: "24px",
    maxHeight: "90vh",
    overflow: "hidden",
    outline: "none",
    display: "flex",
    flexDirection: "column",
  },
  scrollableBody: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    marginBottom: "20px",
    paddingRight: "4px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#606479",
      borderRadius: "3px",
    },
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: "20px",
    flexShrink: 0,
  },
  title: {
    fontSize: "24px !important",
    fontWeight: "500 !important",
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: "13px !important",
    color: theme.palette.text.tertiary,
    marginTop: "4px !important",
  },
  label: {
    fontSize: "14px !important",
    color: theme.palette.text.tertiary,
    marginBottom: "8px !important",
  },
  iconGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(10, 1fr)",
    gap: "8px",
    marginTop: "8px",
  },
  iconButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    backgroundColor: "#252A38",
    border: "1px solid #606479",
    cursor: "pointer",
    transition: "border-color 0.2s ease, background-color 0.2s ease",
    padding: 0,
  },
  iconButtonSelected: {
    border: "1px solid #6C65D9",
    backgroundColor: "rgba(108, 101, 217, 0.15)",
  },
  pagesGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
    marginTop: "8px",
  },
  pageRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "10px 12px",
    borderRadius: "8px",
    backgroundColor: "#252A38",
    cursor: "pointer",
    minHeight: "44px",
    transition: "border-color 0.2s ease",
  },
  pageRowSelected: {
    border: "1px solid #6C65D9",
  },
  pageRowUnselected: {
    border: "1px solid transparent",
  },
  pageRowContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },
  pageLabel: {
    fontSize: "13px !important",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  section: {
    marginBottom: "20px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  footer: {
    flexShrink: 0,
  },
}));

export default useStyles;
